import { Dimensions, Position } from 'types'

export function fitDimensions(dimensions: Dimensions, targetDimensions: Dimensions): Position {
    const { height: maxHeight, width: maxWidth } = targetDimensions
    const aspectRatio = dimensions.width / dimensions.height
    let width = maxWidth
    let height = Math.round(width / aspectRatio)

    if (height > maxHeight) {
        height = maxHeight
        width = Math.round(height * aspectRatio)
    }

    return {
        height,
        width,
        x: Math.round((maxWidth - width) / 2),
        y: Math.round((maxHeight - height) / 2),
    }
}
